// extracted by mini-css-extract-plugin
export default {"wrapper":"l3-z"};